import React from 'react';

const AddIcon = () => (
    <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M22 13.0714H12.5714V22.5H9.42857V13.0714H0V9.92857H9.42857V0.5H12.5714V9.92857H22V13.0714Z"
            fill="white"
        />
    </svg>
);

export { AddIcon };
